// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/Gotham Medium.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/Gotham Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/Gotham Book.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/left-ui.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/left-ui-game.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/button-checkbox-up.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/button-checkbox.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("assets/digit-box.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("assets/leaderboard-row.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("assets/gold.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("assets/silver.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("assets/bronze.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::-webkit-scrollbar {
	width: .5em;
}

::-webkit-scrollbar-track {
	border-radius: 1rem;
	background: #666666;
}

::-webkit-scrollbar-thumb {
	border-radius: 1rem;
	background: #091c47;
}

@font-face {
	font-family: Gotham;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

@font-face {
	font-family: Gotham;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
	font-weight: bold;
}

@font-face {
	font-family: Gotham-Book;
	src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

html,
body {
	width: 100%;
	height: 100%;
	overflow: hidden;
	margin: 0;
	padding: 0;
	background: white;
	font-family: Gotham;
	font-size: min(calc(100vw / 192), calc(100vh / 108));
	background: white;
	color:white;
	text-size-adjust: 100%;
	-ms-text-size-adjust: 100%;
	-moz-text-size-adjust: 100%;
	-webkit-text-size-adjust: 100%;
		-webkit-user-select: none; /* Safari */
	-ms-user-select: none; /* IE 10 and IE 11 */
	user-select: none; /* Standard syntax */

}

#app .hide {
	display:none;
}

button {
	height: 6rem;
	width: 25rem;
	border: .1rem solid #091c47;
	border-radius: 2.9rem;
	background: #091c47;
	font-size: 2rem;
	font-weight: bold;
	line-height: 1em;
	cursor:pointer;
	color:white;
}

#root {
	height:108rem;
  display: flex;
  background: #130f40;
}

.container {
	display:flex;
	position:absolute;
	top:50%; left:50%;
	transform:translate(-50%, -50%);
	width:192rem;
	height:108rem;
	overflow:hidden;
	font-size:3rem;
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_3___});
	background-size: cover;
	background-repeat: no-repeat;
	background-position: center;
}

#title {
	position:absolute;
	top:2.5rem;
	right:0;
	width: 61.5rem;
	height:8.5rem;
}

#sidebar {
	width:63rem;
	height:108rem;
	display:flex;
	flex-direction: column;
	justify-content: space-between;
	position:relative;
	align-items: center;
	z-index:2;
}

#sideBg {
	position:absolute;
	top:0;
	left:0;
	width:74rem;
	height:108rem;
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_4___});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: left;
	z-index:1;
}

.gaming #sideBg,
.start #sideBg {
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.mode .gameDetails,
.home .gameDetails,
.gameWon .gameDetails,
.gameOver .gameDetails,
.gameOver #sideBack,
.gameWon #sideBack,
.mode #sideBack,
.gameOver #sidebar .mode,
.gameWon #sidebar .mode,
.mode #sidebar .mode {
	display:none;
}

#homePage,
#modePage,
#leaderboard {
	display:none;
	flex-direction:column;
}

.home #homePage,
.mode #modePage,
.gameOver #leaderboard,
.gameWon #leaderboard {
	position:absolute;
	top:0;
	right:0;
	display:flex;
	width: 129rem;
	height: 108rem;
	justify-content: center;
	align-items: center;
	z-index:2;
}

#contentBox {
	position:absolute;
	bottom:0;
	right:0;
	width:155rem;
	height:75rem;
	z-index:0;
}

.gaming #contentBox,
.start #contentBox {
	display:none;
}

.topTitle {
	position:absolute;
	top: 25rem;
	left:33rem;
	height:6rem;
}

.easyBox,
.complexBox {
	position:absolute;
	top:42rem;
	width:50rem;
	display:flex;
	flex-direction:column;
	align-items: center;
	justify-content: start;
}

.easyBox {
	right:60rem;
}

.complexBox {
	right:7rem;
}

.modeTitle {
	font-size:3rem;
	width:39rem;
	border-bottom:.1rem solid white;
	padding-bottom:.15rem;
	margin-bottom:.4rem;
	text-align: center;
}

#leaderboard .modeTitle {
	position:absolute;
	top:42rem;
	width:92.9rem;
	right:12.5rem;
}

#leaderboard .modeTitle.player {
	top:81rem;
}

.modeSubTitle {
	font-family: Gotham-Book;
	font-size:2rem;
	width:50rem;
	text-align: center;
}

.easyBox img,
.complexBox img {
	margin: 8.1rem 0 9rem;
	width:50rem;
	cursor:pointer;
}

#userContainer {
	position:absolute;
	top:40rem;
	left:31rem;
	display:flex;
	flex-direction:column;
	align-items: center;
	justify-content: start;
	font-size:2.5rem;
}

.playerLabel,
.emailLabel {
	margin-top:2rem;
}

#playerEmail,
#playerName {
	height:4.5rem;
	font-size:2.5rem;
	font-weight:bold;
	line-height:4.5rem;
	width:67rem;
	overflow:hidden;
	text-overflow:ellipsis;
	text-align:center;
	padding:.5rem 2rem;
	border:.2rem solid #888;
	background:white;
	color:#091c47;
	outline:none;
}

.maxName {
	float:right;
	margin-top: 0.8rem;
	font-size:1.5rem;
}

#playerName:focus,
#playerEmail:focus,
#playerEmail.highlight,
#playerName.highlight {
	border:.2rem solid #091c47;
}

.consentRow {
	display:flex;
	margin-top:1rem;
	width:71.2rem;
	gap:1rem;
	font-size:.9rem;
	font-family:Gotham-book;
	justify-content: start;
	align-items: start;
}

#consentBox {
	margin-top:1rem;
	width:2.5rem;
	height:2.5rem;
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_6___});
	background-size:contain;
}

#consentBox.yes {
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.consentRow p {
	width: 67.7rem;
}

.keyboardContainer {
    display:flex;
    flex-direction:column;
    gap:.5rem;
    margin:1.5rem 0 3rem;
}

.keyboardContainer .row {
    display:flex;
    gap:.5rem;
    justify-content: center;
}

.keyboardContainer .key {
    display:flex;
    justify-content: center;
    align-items: center;
    width:4.8rem;
    height:4.8rem;
    font-size: 1.9rem;
		border:.1rem solid white;
		cursor:pointer;
}

.keyboardContainer .key.long,
.keyboardContainer .key.back {
    width: 7.8rem;
}

.keyboardContainer .key.space {
    width: 52rem;
}

.keyboardContainer .key.back img {
    width: 3rem;
    height:1.8rem;
}

h1 {
	color:#ec008e;
	font-size:4rem;
	margin-bottom:3rem;
}

#sidebar .mode {
	position: absolute;
	top: 16rem;
	left: 24rem;
	width: 19.5rem;
	height: 4rem;
	font-size: 2rem;
	line-height: 4rem;
	background-color: #ec008e;
	clip-path: polygon(0 0, 95% 0, 100% 50%, 95% 100%, 0 100%);
	padding: 0 1.5rem;
}

#sideBack {
	position:absolute;
	bottom:5rem;
	left:5rem;
	width:6rem;
	height:6rem;
	cursor:pointer;
}

.gameDetails {
	position:absolute;
	top:20rem;
	left:24rem;
	display:flex;
	flex-direction: column;
	justify-content: start;
	align-items: start;
}

.scoreLabel, .timerLabel {
	font-size:2.25rem;
	font-weight:bold;
	margin: 3.25rem 0 .5rem;
}

.gameDetails .score {
	width:21rem;
	height:6.5rem;
	padding:.5rem 1rem .5rem .5rem;
	background:white;
	font-size:5rem;
	font-weight:bold;
	text-align:right;
	color:#001b49;
}

.timer {
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_8___});
	background-size:contain;
	width:22.5rem;
	height:6.5rem;
	font-family: Gotham-Book;
	font-size:4.5rem;
	padding:1rem 0 0;
	margin-bottom:6rem;
	display:flex;
	justify-content: center;
	gap:.4rem;
}

.timer .left1,
.timer .left2,
.timer .right1,
.timer .right2 {
	text-align: center;
	width: 5rem;
}

.timer .space {
	width:.7rem;
}

.gameDetails .name {
	font-family: Gotham-Book;
	font-size:3rem;
}

.gameDetails .name img {
	height:2.1rem;
	margin-right:.5rem;
}

#readyCover {
	position:fixed;
	top:0; left:0;
	background:rgba(255, 255, 255, .95);
	width:192rem;
	height:108rem;
	font-size:10rem;
	display:none;
}

.start #readyCover {
	display:block;
	z-index:5;
}

#readyCover #readyCountdown {
  width:192rem;
  height:108rem;
}

.lbContainer {
	position:absolute;
	top:50rem;
	right:11.9rem;
	display:flex;
	gap:14rem;
}

#leaderboard .row {
	display:flex;
	align-items: center;
	width: round(up, 39.9rem, 1px);
	height: round(up, 5.5rem, 1px);
	padding-bottom:.4rem;
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_9___});
	background-size:contain;
	background-repeat: no-repeat;
	font-size:2rem;
	font-weight:bold;
}

#leaderboard .row .position {
	width:10rem;
	position:relative;
}

#leaderboard .row .position .num {
	position: absolute;
	top: -2.2rem;
	left: 1.2rem;
	width: 4.1rem;
	height: 5.45rem;
	padding-top: 0.8rem;
	padding-right: 0.45rem;
	text-align: center;
}

#leaderboard .row .position .num[data-p="0"] {
	color:#091c47;
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_10___});
	background-size:contain;
}

#leaderboard .row .position .num[data-p="1"] {
	color:#091c47;
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_11___});
	background-size:contain;
}

#leaderboard .row .position .num[data-p="2"] {
	color:#091c47;
	background-image:url(${___CSS_LOADER_URL_REPLACEMENT_12___});
	background-size:contain;
}

#leaderboard .row .name {
	width: 17rem;
	padding-right: 1rem;
	color: #091c47;
	overflow: hidden;
	text-overflow: ellipsis;
}

#leaderboard .row .score {
	width:10rem;
	text-align:right;
	font-size:2.25rem;
	font-weight:normal;
}

.lbHeader {
	display:flex;
	font-size:1.25rem;
	font-weight:bold;
}

.lbHeader .position {
	width:9rem;
	margin-left:1rem;
}

.lbHeader .name {
	width:18rem;
}

.lbHeader .score {
	width:9.5rem;
	margin-left:.5rem;
	text-align:center;	
}

#playerPosition {
	position:absolute;
	bottom:14rem;
	right:39rem;	
}

#restartButton {
	position:absolute;
	bottom:5rem;
	right:46rem;	
}

#landscape_notice {
	position: absolute;
	height: 100%;
	width: 100%;
	background: #222;
	top: 0;
	left: 0;
	display: flex;
	z-index: 200;
	justify-content: center;
	align-items: center;
}

#landscape_notice p {
	text-align: center;
	background: white;
	color: black;
	width: 75%;
	padding: 5%;
	border-radius: 4rem;
	font-size: 3.5vmin;
	line-height: 1.3em;
}`, "",{"version":3,"sources":["webpack://./public/style.css"],"names":[],"mappings":"AAAA;CACC,WAAW;AACZ;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,4CAAoC;AACrC;;AAEA;CACC,mBAAmB;CACnB,4CAAkC;CAClC,iBAAiB;AAClB;;AAEA;CACC,wBAAwB;CACxB,4CAAkC;AACnC;;AAEA;;CAEC,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,SAAS;CACT,UAAU;CACV,iBAAiB;CACjB,mBAAmB;CACnB,oDAAoD;CACpD,iBAAiB;CACjB,WAAW;CACX,sBAAsB;CACtB,0BAA0B;CAC1B,2BAA2B;CAC3B,8BAA8B;EAC7B,yBAAyB,EAAE,WAAW;CACvC,qBAAqB,EAAE,oBAAoB;CAC3C,iBAAiB,EAAE,oBAAoB;;AAExC;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,2BAA2B;CAC3B,qBAAqB;CACrB,mBAAmB;CACnB,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,aAAa;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,OAAO,EAAE,QAAQ;CACjB,+BAA+B;CAC/B,YAAY;CACZ,aAAa;CACb,eAAe;CACf,cAAc;CACd,wDAAqC;CACrC,sBAAsB;CACtB,4BAA4B;CAC5B,2BAA2B;AAC5B;;AAEA;CACC,iBAAiB;CACjB,UAAU;CACV,OAAO;CACP,cAAc;CACd,aAAa;AACd;;AAEA;CACC,WAAW;CACX,aAAa;CACb,YAAY;CACZ,sBAAsB;CACtB,8BAA8B;CAC9B,iBAAiB;CACjB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,iBAAiB;CACjB,KAAK;CACL,MAAM;CACN,WAAW;CACX,aAAa;CACb,wDAA0C;CAC1C,wBAAwB;CACxB,4BAA4B;CAC5B,yBAAyB;CACzB,SAAS;AACV;;AAEA;;CAEC,wDAA+C;AAChD;;AAEA;;;;;;;;;;CAUC,YAAY;AACb;;AAEA;;;CAGC,YAAY;CACZ,qBAAqB;AACtB;;AAEA;;;;CAIC,iBAAiB;CACjB,KAAK;CACL,OAAO;CACP,YAAY;CACZ,aAAa;CACb,cAAc;CACd,uBAAuB;CACvB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,iBAAiB;CACjB,QAAQ;CACR,OAAO;CACP,YAAY;CACZ,YAAY;CACZ,SAAS;AACV;;AAEA;;CAEC,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,UAAU;CACV,UAAU;CACV,WAAW;AACZ;;AAEA;;CAEC,iBAAiB;CACjB,SAAS;CACT,WAAW;CACX,YAAY;CACZ,qBAAqB;CACrB,mBAAmB;CACnB,sBAAsB;AACvB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,cAAc;CACd,WAAW;CACX,+BAA+B;CAC/B,qBAAqB;CACrB,mBAAmB;CACnB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,SAAS;CACT,aAAa;CACb,aAAa;AACd;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,wBAAwB;CACxB,cAAc;CACd,WAAW;CACX,kBAAkB;AACnB;;AAEA;;CAEC,qBAAqB;CACrB,WAAW;CACX,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,SAAS;CACT,UAAU;CACV,YAAY;CACZ,qBAAqB;CACrB,mBAAmB;CACnB,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;;CAEC,eAAe;AAChB;;AAEA;;CAEC,aAAa;CACb,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,sBAAsB;CACtB,iBAAiB;CACjB,kBAAkB;CAClB,uBAAuB;CACvB,gBAAgB;CAChB,aAAa;CACb,YAAY;AACb;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;;;;CAIC,0BAA0B;AAC3B;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,aAAa;CACb,QAAQ;CACR,eAAe;CACf,uBAAuB;CACvB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,eAAe;CACf,YAAY;CACZ,aAAa;CACb,wDAAmD;CACnD,uBAAuB;AACxB;;AAEA;CACC,wDAAgD;AACjD;;AAEA;CACC,cAAc;AACf;;AAEA;IACI,YAAY;IACZ,qBAAqB;IACrB,SAAS;IACT,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;CACC,aAAa;CACb,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,cAAc;CACd,YAAY;CACZ,eAAe;CACf,iBAAiB;CACjB,yBAAyB;CACzB,0DAA0D;CAC1D,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,SAAS;CACT,UAAU;CACV,WAAW;CACX,cAAc;AACf;;AAEA;CACC,iBAAiB;CACjB,SAAS;CACT,UAAU;CACV,YAAY;CACZ,sBAAsB;CACtB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,aAAa;CACb,8BAA8B;CAC9B,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,aAAa;AACd;;AAEA;CACC,wDAA0C;CAC1C,uBAAuB;CACvB,aAAa;CACb,aAAa;CACb,wBAAwB;CACxB,gBAAgB;CAChB,gBAAgB;CAChB,kBAAkB;CAClB,YAAY;CACZ,uBAAuB;CACvB,SAAS;AACV;;AAEA;;;;CAIC,kBAAkB;CAClB,WAAW;AACZ;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,wBAAwB;CACxB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,KAAK,EAAE,MAAM;CACb,mCAAmC;CACnC,YAAY;CACZ,aAAa;CACb,eAAe;CACf,YAAY;AACb;;AAEA;CACC,aAAa;CACb,SAAS;AACV;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;CACC,iBAAiB;CACjB,SAAS;CACT,aAAa;CACb,YAAY;CACZ,SAAS;AACV;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,8BAA8B;CAC9B,8BAA8B;CAC9B,oBAAoB;CACpB,wDAAgD;CAChD,uBAAuB;CACvB,4BAA4B;CAC5B,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,aAAa;CACb,eAAe;CACf,mBAAmB;CACnB,sBAAsB;CACtB,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,yDAAqC;CACrC,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,yDAAuC;CACvC,uBAAuB;AACxB;;AAEA;CACC,aAAa;CACb,yDAAuC;CACvC,uBAAuB;AACxB;;AAEA;CACC,YAAY;CACZ,mBAAmB;CACnB,cAAc;CACd,gBAAgB;CAChB,uBAAuB;AACxB;;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,gBAAgB;AACjB;;AAEA;CACC,UAAU;CACV,gBAAgB;AACjB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,YAAY;CACZ,iBAAiB;CACjB,iBAAiB;AAClB;;AAEA;CACC,iBAAiB;CACjB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,WAAW;AACZ;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,WAAW;CACX,gBAAgB;CAChB,MAAM;CACN,OAAO;CACP,aAAa;CACb,YAAY;CACZ,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;CAClB,iBAAiB;CACjB,YAAY;CACZ,UAAU;CACV,WAAW;CACX,mBAAmB;CACnB,kBAAkB;CAClB,kBAAkB;AACnB","sourcesContent":["::-webkit-scrollbar {\n\twidth: .5em;\n}\n\n::-webkit-scrollbar-track {\n\tborder-radius: 1rem;\n\tbackground: #666666;\n}\n\n::-webkit-scrollbar-thumb {\n\tborder-radius: 1rem;\n\tbackground: #091c47;\n}\n\n@font-face {\n\tfont-family: Gotham;\n\tsrc: url(\"assets/Gotham Medium.otf\");\n}\n\n@font-face {\n\tfont-family: Gotham;\n\tsrc: url(\"assets/Gotham Bold.otf\");\n\tfont-weight: bold;\n}\n\n@font-face {\n\tfont-family: Gotham-Book;\n\tsrc: url(\"assets/Gotham Book.otf\");\n}\n\nhtml,\nbody {\n\twidth: 100%;\n\theight: 100%;\n\toverflow: hidden;\n\tmargin: 0;\n\tpadding: 0;\n\tbackground: white;\n\tfont-family: Gotham;\n\tfont-size: min(calc(100vw / 192), calc(100vh / 108));\n\tbackground: white;\n\tcolor:white;\n\ttext-size-adjust: 100%;\n\t-ms-text-size-adjust: 100%;\n\t-moz-text-size-adjust: 100%;\n\t-webkit-text-size-adjust: 100%;\n\t\t-webkit-user-select: none; /* Safari */\n\t-ms-user-select: none; /* IE 10 and IE 11 */\n\tuser-select: none; /* Standard syntax */\n\n}\n\n#app .hide {\n\tdisplay:none;\n}\n\nbutton {\n\theight: 6rem;\n\twidth: 25rem;\n\tborder: .1rem solid #091c47;\n\tborder-radius: 2.9rem;\n\tbackground: #091c47;\n\tfont-size: 2rem;\n\tfont-weight: bold;\n\tline-height: 1em;\n\tcursor:pointer;\n\tcolor:white;\n}\n\n#root {\n\theight:108rem;\n  display: flex;\n  background: #130f40;\n}\n\n.container {\n\tdisplay:flex;\n\tposition:absolute;\n\ttop:50%; left:50%;\n\ttransform:translate(-50%, -50%);\n\twidth:192rem;\n\theight:108rem;\n\toverflow:hidden;\n\tfont-size:3rem;\n\tbackground-image:url('assets/bg.png');\n\tbackground-size: cover;\n\tbackground-repeat: no-repeat;\n\tbackground-position: center;\n}\n\n#title {\n\tposition:absolute;\n\ttop:2.5rem;\n\tright:0;\n\twidth: 61.5rem;\n\theight:8.5rem;\n}\n\n#sidebar {\n\twidth:63rem;\n\theight:108rem;\n\tdisplay:flex;\n\tflex-direction: column;\n\tjustify-content: space-between;\n\tposition:relative;\n\talign-items: center;\n\tz-index:2;\n}\n\n#sideBg {\n\tposition:absolute;\n\ttop:0;\n\tleft:0;\n\twidth:74rem;\n\theight:108rem;\n\tbackground-image:url('assets/left-ui.png');\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: left;\n\tz-index:1;\n}\n\n.gaming #sideBg,\n.start #sideBg {\n\tbackground-image:url('assets/left-ui-game.png');\n}\n\n.mode .gameDetails,\n.home .gameDetails,\n.gameWon .gameDetails,\n.gameOver .gameDetails,\n.gameOver #sideBack,\n.gameWon #sideBack,\n.mode #sideBack,\n.gameOver #sidebar .mode,\n.gameWon #sidebar .mode,\n.mode #sidebar .mode {\n\tdisplay:none;\n}\n\n#homePage,\n#modePage,\n#leaderboard {\n\tdisplay:none;\n\tflex-direction:column;\n}\n\n.home #homePage,\n.mode #modePage,\n.gameOver #leaderboard,\n.gameWon #leaderboard {\n\tposition:absolute;\n\ttop:0;\n\tright:0;\n\tdisplay:flex;\n\twidth: 129rem;\n\theight: 108rem;\n\tjustify-content: center;\n\talign-items: center;\n\tz-index:2;\n}\n\n#contentBox {\n\tposition:absolute;\n\tbottom:0;\n\tright:0;\n\twidth:155rem;\n\theight:75rem;\n\tz-index:0;\n}\n\n.gaming #contentBox,\n.start #contentBox {\n\tdisplay:none;\n}\n\n.topTitle {\n\tposition:absolute;\n\ttop: 25rem;\n\tleft:33rem;\n\theight:6rem;\n}\n\n.easyBox,\n.complexBox {\n\tposition:absolute;\n\ttop:42rem;\n\twidth:50rem;\n\tdisplay:flex;\n\tflex-direction:column;\n\talign-items: center;\n\tjustify-content: start;\n}\n\n.easyBox {\n\tright:60rem;\n}\n\n.complexBox {\n\tright:7rem;\n}\n\n.modeTitle {\n\tfont-size:3rem;\n\twidth:39rem;\n\tborder-bottom:.1rem solid white;\n\tpadding-bottom:.15rem;\n\tmargin-bottom:.4rem;\n\ttext-align: center;\n}\n\n#leaderboard .modeTitle {\n\tposition:absolute;\n\ttop:42rem;\n\twidth:92.9rem;\n\tright:12.5rem;\n}\n\n#leaderboard .modeTitle.player {\n\ttop:81rem;\n}\n\n.modeSubTitle {\n\tfont-family: Gotham-Book;\n\tfont-size:2rem;\n\twidth:50rem;\n\ttext-align: center;\n}\n\n.easyBox img,\n.complexBox img {\n\tmargin: 8.1rem 0 9rem;\n\twidth:50rem;\n\tcursor:pointer;\n}\n\n#userContainer {\n\tposition:absolute;\n\ttop:40rem;\n\tleft:31rem;\n\tdisplay:flex;\n\tflex-direction:column;\n\talign-items: center;\n\tjustify-content: start;\n\tfont-size:2.5rem;\n}\n\n.playerLabel,\n.emailLabel {\n\tmargin-top:2rem;\n}\n\n#playerEmail,\n#playerName {\n\theight:4.5rem;\n\tfont-size:2.5rem;\n\tfont-weight:bold;\n\tline-height:4.5rem;\n\twidth:67rem;\n\toverflow:hidden;\n\ttext-overflow:ellipsis;\n\ttext-align:center;\n\tpadding:.5rem 2rem;\n\tborder:.2rem solid #888;\n\tbackground:white;\n\tcolor:#091c47;\n\toutline:none;\n}\n\n.maxName {\n\tfloat:right;\n\tmargin-top: 0.8rem;\n\tfont-size:1.5rem;\n}\n\n#playerName:focus,\n#playerEmail:focus,\n#playerEmail.highlight,\n#playerName.highlight {\n\tborder:.2rem solid #091c47;\n}\n\n.consentRow {\n\tdisplay:flex;\n\tmargin-top:1rem;\n\twidth:71.2rem;\n\tgap:1rem;\n\tfont-size:.9rem;\n\tfont-family:Gotham-book;\n\tjustify-content: start;\n\talign-items: start;\n}\n\n#consentBox {\n\tmargin-top:1rem;\n\twidth:2.5rem;\n\theight:2.5rem;\n\tbackground-image:url(assets/button-checkbox-up.png);\n\tbackground-size:contain;\n}\n\n#consentBox.yes {\n\tbackground-image:url(assets/button-checkbox.png);\n}\n\n.consentRow p {\n\twidth: 67.7rem;\n}\n\n.keyboardContainer {\n    display:flex;\n    flex-direction:column;\n    gap:.5rem;\n    margin:1.5rem 0 3rem;\n}\n\n.keyboardContainer .row {\n    display:flex;\n    gap:.5rem;\n    justify-content: center;\n}\n\n.keyboardContainer .key {\n    display:flex;\n    justify-content: center;\n    align-items: center;\n    width:4.8rem;\n    height:4.8rem;\n    font-size: 1.9rem;\n\t\tborder:.1rem solid white;\n\t\tcursor:pointer;\n}\n\n.keyboardContainer .key.long,\n.keyboardContainer .key.back {\n    width: 7.8rem;\n}\n\n.keyboardContainer .key.space {\n    width: 52rem;\n}\n\n.keyboardContainer .key.back img {\n    width: 3rem;\n    height:1.8rem;\n}\n\nh1 {\n\tcolor:#ec008e;\n\tfont-size:4rem;\n\tmargin-bottom:3rem;\n}\n\n#sidebar .mode {\n\tposition: absolute;\n\ttop: 16rem;\n\tleft: 24rem;\n\twidth: 19.5rem;\n\theight: 4rem;\n\tfont-size: 2rem;\n\tline-height: 4rem;\n\tbackground-color: #ec008e;\n\tclip-path: polygon(0 0, 95% 0, 100% 50%, 95% 100%, 0 100%);\n\tpadding: 0 1.5rem;\n}\n\n#sideBack {\n\tposition:absolute;\n\tbottom:5rem;\n\tleft:5rem;\n\twidth:6rem;\n\theight:6rem;\n\tcursor:pointer;\n}\n\n.gameDetails {\n\tposition:absolute;\n\ttop:20rem;\n\tleft:24rem;\n\tdisplay:flex;\n\tflex-direction: column;\n\tjustify-content: start;\n\talign-items: start;\n}\n\n.scoreLabel, .timerLabel {\n\tfont-size:2.25rem;\n\tfont-weight:bold;\n\tmargin: 3.25rem 0 .5rem;\n}\n\n.gameDetails .score {\n\twidth:21rem;\n\theight:6.5rem;\n\tpadding:.5rem 1rem .5rem .5rem;\n\tbackground:white;\n\tfont-size:5rem;\n\tfont-weight:bold;\n\ttext-align:right;\n\tcolor:#001b49;\n}\n\n.timer {\n\tbackground-image:url(assets/digit-box.png);\n\tbackground-size:contain;\n\twidth:22.5rem;\n\theight:6.5rem;\n\tfont-family: Gotham-Book;\n\tfont-size:4.5rem;\n\tpadding:1rem 0 0;\n\tmargin-bottom:6rem;\n\tdisplay:flex;\n\tjustify-content: center;\n\tgap:.4rem;\n}\n\n.timer .left1,\n.timer .left2,\n.timer .right1,\n.timer .right2 {\n\ttext-align: center;\n\twidth: 5rem;\n}\n\n.timer .space {\n\twidth:.7rem;\n}\n\n.gameDetails .name {\n\tfont-family: Gotham-Book;\n\tfont-size:3rem;\n}\n\n.gameDetails .name img {\n\theight:2.1rem;\n\tmargin-right:.5rem;\n}\n\n#readyCover {\n\tposition:fixed;\n\ttop:0; left:0;\n\tbackground:rgba(255, 255, 255, .95);\n\twidth:192rem;\n\theight:108rem;\n\tfont-size:10rem;\n\tdisplay:none;\n}\n\n.start #readyCover {\n\tdisplay:block;\n\tz-index:5;\n}\n\n#readyCover #readyCountdown {\n  width:192rem;\n  height:108rem;\n}\n\n.lbContainer {\n\tposition:absolute;\n\ttop:50rem;\n\tright:11.9rem;\n\tdisplay:flex;\n\tgap:14rem;\n}\n\n#leaderboard .row {\n\tdisplay:flex;\n\talign-items: center;\n\twidth: round(up, 39.9rem, 1px);\n\theight: round(up, 5.5rem, 1px);\n\tpadding-bottom:.4rem;\n\tbackground-image:url(assets/leaderboard-row.png);\n\tbackground-size:contain;\n\tbackground-repeat: no-repeat;\n\tfont-size:2rem;\n\tfont-weight:bold;\n}\n\n#leaderboard .row .position {\n\twidth:10rem;\n\tposition:relative;\n}\n\n#leaderboard .row .position .num {\n\tposition: absolute;\n\ttop: -2.2rem;\n\tleft: 1.2rem;\n\twidth: 4.1rem;\n\theight: 5.45rem;\n\tpadding-top: 0.8rem;\n\tpadding-right: 0.45rem;\n\ttext-align: center;\n}\n\n#leaderboard .row .position .num[data-p=\"0\"] {\n\tcolor:#091c47;\n\tbackground-image:url(assets/gold.png);\n\tbackground-size:contain;\n}\n\n#leaderboard .row .position .num[data-p=\"1\"] {\n\tcolor:#091c47;\n\tbackground-image:url(assets/silver.png);\n\tbackground-size:contain;\n}\n\n#leaderboard .row .position .num[data-p=\"2\"] {\n\tcolor:#091c47;\n\tbackground-image:url(assets/bronze.png);\n\tbackground-size:contain;\n}\n\n#leaderboard .row .name {\n\twidth: 17rem;\n\tpadding-right: 1rem;\n\tcolor: #091c47;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n#leaderboard .row .score {\n\twidth:10rem;\n\ttext-align:right;\n\tfont-size:2.25rem;\n\tfont-weight:normal;\n}\n\n.lbHeader {\n\tdisplay:flex;\n\tfont-size:1.25rem;\n\tfont-weight:bold;\n}\n\n.lbHeader .position {\n\twidth:9rem;\n\tmargin-left:1rem;\n}\n\n.lbHeader .name {\n\twidth:18rem;\n}\n\n.lbHeader .score {\n\twidth:9.5rem;\n\tmargin-left:.5rem;\n\ttext-align:center;\t\n}\n\n#playerPosition {\n\tposition:absolute;\n\tbottom:14rem;\n\tright:39rem;\t\n}\n\n#restartButton {\n\tposition:absolute;\n\tbottom:5rem;\n\tright:46rem;\t\n}\n\n#landscape_notice {\n\tposition: absolute;\n\theight: 100%;\n\twidth: 100%;\n\tbackground: #222;\n\ttop: 0;\n\tleft: 0;\n\tdisplay: flex;\n\tz-index: 200;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n#landscape_notice p {\n\ttext-align: center;\n\tbackground: white;\n\tcolor: black;\n\twidth: 75%;\n\tpadding: 5%;\n\tborder-radius: 4rem;\n\tfont-size: 3.5vmin;\n\tline-height: 1.3em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
